import React from 'react';
import Title from './component/Title';
import SectionOne from './component/SectionOne';
import Tesimonials from '../../../Pages/About/component/Testimonial';
import Cta from '../../../Pages/About/component/Cta';
import Funfact from '../../../Pages/About/component/Funfact';
import Contact from '../../../Pages/Home/component/Contact';
import TenantsFAQ from './component/TenantsFAQ';
const index = () => {
    return (
        <>
            <Title />
            <SectionOne />
            <Cta />
            <Funfact />
            <Tesimonials />
            <Contact />
            <TenantsFAQ />
        </>
    );
};

export default index;
